import React from 'react';
import { Newspaper } from 'lucide-react';
import CrudManager from '../../components/admin/CrudManager';
import { getMedia, createMedia, updateMedia, deleteMedia } from '../../utils/api';

const fields = [
  { name: 'title', label: 'Headline / Title', type: 'text', required: true },
  { name: 'outlet', label: 'Media Outlet', type: 'text', required: true, placeholder: 'e.g. Dainik Bhaskar' },
  { name: 'date', label: 'Date', type: 'text' },
  { name: 'excerpt', label: 'Short Excerpt', type: 'textarea', rows: 3 },
  { name: 'image', label: 'Image / Clipping', type: 'image' },
  { name: 'link', label: 'Article Link', type: 'text', placeholder: 'https://...' },
];

export default function AdminMedia() {
  return (
    <CrudManager
      title="Media Coverage"
      subtitle="Manage newspaper articles, TV interviews & online news"
      fields={fields}
      fetchFn={getMedia}
      createFn={createMedia}
      updateFn={updateMedia}
      deleteFn={deleteMedia}
      cardRenderer={(item) => (
        <div>
          {item.image && <img src={item.image} alt={item.title} className="w-full h-40 object-cover" />}
          <div className="p-4">
            <div className="flex items-center gap-1 text-xs text-orange-600 font-semibold mb-1">
              <Newspaper className="h-3 w-3" /> {item.outlet} {item.date && `• ${item.date}`}
            </div>
            <h3 className="font-bold text-slate-900 line-clamp-2">{item.title}</h3>
          </div>
        </div>
      )}
    />
  );
}
